import { productOptions } from '@/utils/common';

export const getFormFields = () => [
  {
    name: 'productId',
    componentName: 'dropdown',
    params: {
      i18nLabel: 'lots.product',
      options: productOptions(),
    },
    rules: [{ required: true }],
  },
];
